import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-ktostamm-kunde-master-view',
  imports: [],
  templateUrl: './ktostamm-kunde.master-view.html',
  styleUrls: ['./ktostamm-kunde.master-view.css'],
})
export class KtostammKundeMasterView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
